// extracted by mini-css-extract-plugin
export default {"linkatv":"colors_linkatv__ecPXi","linkdeatv":"colors_linkdeatv__pwFqh"};